import { Injectable } from '@angular/core';

import { BetslipV2ParticipantPick } from '../../../../../core/picks/betslip-v2-participant-pick';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class AccaBoostNotARacePickValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.ParticipantBetSelected;
    isValid(_: IRewardToken, state: TokenValidationInput): boolean {
        return state.selectedPicks.every((pick) => !BetslipV2ParticipantPick.isPick(pick));
    }
}
